// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._7eFIs{justify-content:space-between;padding:16px;border:1px solid #e2e2e2;background-color:#fff;border-radius:8px;color:#0082ff;font-size:16px;line-height:24px}.ZV4oo,._7eFIs{display:flex;align-items:center}.ZV4oo{width:24px;height:24px;flex:0 0 24px;justify-content:center}.ZV4oo>svg{color:#767676}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_7eFIs",
	"icon": "ZV4oo"
};
module.exports = ___CSS_LOADER_EXPORT___;
